export default [{
        label: 'General Lights',
        value: 'LIGHT',
        icon: 'icon-C-01-01',
        icons: [{
                icon: "icon-C-01-01",
                tags: ["LIGHT", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-C-01-02",
                tags: ["LIGHT", "GENERAL", "DARK"],
                position: {
                    row: 1,
                    column: 2
                }

            },
            {
                icon: "icon-C-01-03",
                tags: ["LIGHT", "PLUS", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-C-01-04",
                tags: ["LIGHT", "MINUS", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-C-01-05",
                tags: ["LIGHT", "GENERAL", "SUN", "ALL"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-C-01-07",
                tags: ["LIGHT", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-C-01-08",
                tags: ["LIGHT", "GENERAL", "STAIRCASE", "SUN"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-C-01-12",
                tags: ["LIGHT", "WARDROBE", "SUN", "GENERAL"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-C-01-11",
                tags: ["LIGHT", "GENERAL", "SUN", "KITCHEN"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-C-01-09",
                tags: ["LIGHT", "GENERAL", "BATHROOM", "SUN"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-C-02-03",
                tags: ["LIGHT", "LIGHTBULB", "GENERAL"],
                position: {
                    row: 1,
                    column: 11
                }
            },
            {
                icon: "icon-D-23-10",
                tags: ["LIGHT", "LED", "GENERAL"],
                position: {
                    row: 1,
                    column: 12
                }
            },
            {
                icon: "icon-D-01-01",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-D-01-03",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-D-01-04",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-D-01-05",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 4
                }
            },
            {
                icon: "icon-D-01-08",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-D-01-12",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 6
                }
            },
            {
                icon: "icon-D-01-14",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-D-01-15",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-D-01-16",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 3
                }
            },
            {
                icon: "icon-C-02-06",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 1
				}
            },
            {
                icon: "icon-C-02-07",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 2
                }
            },
            {
                icon: "icon-D-02-07",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 3
                }
            },
            {
                icon: "icon-D-02-06",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 4
                }
            },
            {
                icon: "icon-D-02-08",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 5
                }
            },
            {
                icon: "icon-C-02-01",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 1
                }
            },
            {
                icon: "icon-C-02-02",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 2
                }
            },
            {
                icon: "icon-D-02-12",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 1
                }
            },
            {
                icon: "icon-B-03-09",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 1
                }
            },
        ]
    },
    {
        label: 'Hotel',
        value: 'HOTEL',
        icon: 'icon-D-22-01',
        icons: [{
                icon: "icon-C-05-01",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BELL"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-C-05-02",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BELL"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-C-08-01",
                tags: ["HOTEL", "HOSPITALITY", "MUR", "ROOM"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-C-08-02",
                tags: ["HOTEL", "HOSPITALITY", "STAFF", "ROOM"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-C-08-03",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "DND"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-D-22-03",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "LUGGAGE"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-C-07-01",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "LUGGAGE"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-D-22-01",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "REGISTRATION"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-D-19-01",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "LIFT"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-D-19-02",
                tags: ["HOTEL", "HOSPITALITY", "PAY"],
                position: {
                    row: 3,
                    column: 3
                }
            },
            {
                icon: "icon-D-22-04",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "CONFERENCE"],
                position: {
                    row: 3,
                    column: 4
                }
            },
            {
                icon: "icon-C-07-03",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 1
                }
            },
            {
                icon: "icon-D-22-05",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 2
                }
            },
            {
                icon: "icon-D-22-06",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 3
                }
            },
            {
                icon: "icon-D-22-14",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 4
                }
            },
            {
                icon: "icon-D-22-11",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 5,
                    column: 1
                }
            },
            {
                icon: "icon-D-22-19",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "MUR", "BATHROOM"],
                position: {
                    row: 5,
                    column: 2
                }
            },
            {
                icon: "icon-D-22-20",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 5,
                    column: 3
                }
            },
            {
                icon: "icon-D-22-09",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BED"],
                position: {
                    row: 6,
                    column: 1
                }
            },
            {
                icon: "icon-D-22-10",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BED"],
                position: {
                    row: 6,
                    column: 2
                }
            },
            {
                icon: "icon-D-22-18",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BED", "SOFA"],
                position: {
                    row: 6,
                    column: 3
                }
            },
        ]
    },
    {
        label: 'Interface',
        value: 'INTERFACE',
        icon: 'icon-C-11-01',
        icons: [{
                icon: "icon-C-11-01",
                tags: ["INTERFACE", "MASTER ON/OFF", "CONTROL"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-C-11-13",
                tags: ["INTERFACE", "ARROW", "UP", "CONTROL"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-C-11-14",
                tags: ["INTERFACE", "ARROW", "DOWN", "CONTROL"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-C-10-02",
                tags: ["INTERFACE", "WORD", "OFF", "CONTROL"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-C-10-01",
                tags: ["INTERFACE", "WORD", "ON", "CONTROL"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-C-10-10",
                tags: ["INTERFACE", "WORD", "CELSIUM", "TEMPERATURE", "CONTROL"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-C-10-11",
                tags: ["INTERFACE", "WORD", "FAHRENHEIT", "TEMPERATURE", "CONTROL"],
                position: {
                    row: 2,
                    column: 4
                }
            },
        ]
    },
    {
        label: 'Scene',
        value: 'SCENE',
        icon: 'icon-C-06-01',
        icons: [{
                icon: "icon-C-06-03",
                tags: ["SCENE", "MOON", "DARK", "MOOD"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-C-06-02",
                tags: ["SCENE", "MOOD", "RELAX", "DRINKS"],
                position: {
                    row: 1,
                    column: 2
                }

            },
            {
                icon: "icon-C-06-01",
                tags: ["SCENE", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 3
                }

            },
            {
                icon: "icon-D-15-13",
                tags: ["SCENE", "PILLOW", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-D-15-14",
                tags: ["SCENE", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-D-15-17",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 1
                }

            },
            {
                icon: "icon-D-24-03",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-D-24-04",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 3
                }
            },
        ]
    },
    {
        label: 'Sheers',
        value: 'BLIND',
        icon: 'icon-D-07-07',
        icons: [{
                icon: "icon-C-03-01",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 1
                }

            },
            {
                icon: "icon-C-03-02",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-C-03-03",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 3
                }

            },
            {
                icon: "icon-D-07-04",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-D-07-07",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-C-03-05",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 1
                }

            },
            {
                icon: "icon-C-03-06",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 2
                }

            },
        ]
    },
    {
        label: 'Window/Door',
        value: 'DOOR',
        icon: 'icon-C-02-05',
        icons: [
            {
                icon: "icon-D-08-06",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-D-08-08",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-C-02-05",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 1
                }

            },
            {
                icon: "icon-D-09-02",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-D-09-05",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 2
                }

            },
            {
                icon: "icon-D-09-06",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 3
                }

            },
            {
                icon: "icon-D-09-07",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 4
                }
            },
            {
                icon: "icon-D-25-08",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 1
                }
            },
        ]
    },
    {
        label: 'HVAC',
        value: 'HVAC',
        icon: 'icon-C-04-07',
        icons: [
            {
                icon: "icon-C-04-07",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 1
                }

            },
            {
                icon: "icon-C-04-02",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "COOLING"],
                position: {
                    row: 1,
                    column: 2
                }

            },
            {
                icon: "icon-C-04-03",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "HEATING"],
                position: {
                    row: 1,
                    column: 3
                }

            },
            {
                icon: "icon-C-04-04",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "ECO"],
                position: {
                    row: 1,
                    column: 4
                }

            },
            {
                icon: "icon-D-13-05",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-D-21-05",
                tags: ["HVAC", "CLIMA", "SIGNS", "COOLING", "CONTROL"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-D-13-12",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING", "FAN"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-D-13-15",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-B-13-17",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 3
                }
            },
        ]
    },
    {
        label: 'Media',
        value: 'MEDIA',
        icon: 'icon-C-09-04',
        icons: [{
                icon: "icon-C-09-04",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 1
                }

            },
            {
                icon: "icon-C-07-02",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-D-16-18",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-D-16-19",
                tags: ["MEDIA", "CINEMA", "VIDEO", "CAMERA", "RECORD", "FILMING"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-D-17-07",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 2,
                    column: 4
                }
            },
            {
                icon: "icon-D-17-10",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-D-17-11",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "PROJECTOR", "TV"],
                position: {
                    row: 2,
                    column: 6
                }
            },
            {
                icon: "icon-D-16-20",
                tags: ["MEDIA", "CINEMA", "CONFERENCE", "KARAOKE", "TV"],
                position: {
                    row: 3,
                    column: 1
                }
            },

        ]
    },
    {
        label: 'Kitchen',
        value: 'KITCHEN',
        icon: 'icon-D-04-12',
        icons: [
            {
                icon: "icon-D-04-07",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-D-04-12",
                tags: ["KITCHEN", "RESTAURANT", "EAT", "DINING", "FORK", "SPOON"],
                position: {
                    row: 1,
                    column: 2
                }
            }
        ]
    },
    {
        label: 'Bathroom',
        value: 'BATHROOM',
        icon: 'icon-D-05-16',
        icons: [{
                icon: "icon-D-05-10",
                tags: ["BATHROOM", "TOILET"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-D-05-13",
                tags: ["BATHROOM", "SHOWER"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-D-05-16",
                tags: ["BATHROOM", "SHOWER"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-D-22-11",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-D-22-19",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "MUR", "BATHROOM"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-D-22-20",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 1,
                    column: 6
                }
            }, 
            {
                icon: "icon-D-06-05",
                tags: ["BATHROOM", "TOILET", "WC"],
                position: {
                    row: 2,
                    column: 1
                }
            },
        ]
    },
    {
        label: 'Security',
        value: 'SECURITY',
        icon: 'icon-D-09-08',
        icons: [{
                icon: "icon-D-09-08",
                tags: ["SECURITY", "DOOR", "DOORLOCK"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-D-21-08",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-B-21-12",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 2
                }
            },
        ]
    },
    {
        label: 'Office',
        value: 'OFFICE',
        icon: 'icon-D-10-06',
        icons: [
            {
                icon: "icon-D-10-06",
                tags: ["OFFICE", "IT", "NETWORK", "GAME"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            
        ]
    },
    {
        label: 'Accessories',
        value: 'ACCESSORIES',
        icon: 'icon-D-15-09',
        icons: [
            {
                icon: "icon-D-15-09",
                tags: ["ACCESSORIES", "DECORATION", "FURNITURE"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-D-15-17",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-D-24-03",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-D-24-04",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 3
                }
            },
        ]
    },
    {
        label: 'Fireplace',
        value: 'FIREPLACE',
        icon: 'icon-D-11-01',
        icons: [{
                icon: "icon-D-11-01",
                tags: ["FIREPLACE", "STOVE", "FIRE", "WOOD"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-D-11-07",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-D-11-09",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 3 
                }
            },
        ]
    },
    {
        label: 'Garage',
        value: 'GARAGE',
        icon: 'icon-D-12-06',
        icons: [{
                icon: "icon-D-12-03",
                tags: ["GARAGE"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-D-12-06",
                tags: ["GARAGE"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-D-12-09",
                tags: ["GARAGE", "CAR"],
                position: {
                    row: 1,
                    column: 3
                }
            },
        ]
    },
    {
        label: 'Clima',
        value: 'CLIMA',
        icon: 'icon-D-19-09',
        icons: [
            {
                icon: "icon-D-19-09",
                tags: ["CLIMA", "TECHNICAL", "MACHINE", "FURNACE"],
                position: {
                    row: 1,
                    column: 1
                }
            },
        ]
    },
    {
        label: 'Relax',
        value: 'SPA',
        icon: 'icon-D-14-01',
        icons: [{
                icon: "icon-D-14-01",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-D-14-02",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-D-14-03",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-D-14-05",
                tags: ["SPA", "SAUNA", "RELAX"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-D-14-09",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-D-14-10",
                tags: ["SPA", "RELAX", "MASSAGE"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-D-14-12",
                tags: ["RELAX", "GYM"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-D-15-15",
                tags: ["SPA", "SAUNA", "RELAX", "CANDLES"],
                position: {
                    row: 1,
                    column: 8
                }
            },
        ]
    },
    {
        label: 'Pet',
        value: 'KID',
        icon: 'icon-D-15-03',
        icons: [{
                icon: "icon-D-15-01",
                tags: ["KID", "TOY"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-15-03",
                tags: ["KID", "PET"],
                position: {
                    row: 1,
                    column: 2
                }
            },
        ]
    },
  
    {
        label: 'Sockets',
        value: 'SOCKETS',
        icon: 'icon-D-20-01',
        icons: [{
                icon: "icon-D-20-01",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-D-20-05",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 2
                }
            },
        ]
    },
    {
        label: 'Outdoor Heater',
        value: 'OUTDOOR HEATER',
        icon: 'icon-D-27-04',
        icons: [
            {
                icon: "icon-D-27-04",
                tags: ["OUTDOOR", "CARBON"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-D-27-09",
                tags: ["OUTDOOR", "HEATER", "RADIATOR"],
                position: {
                    row: 1,
                    column: 2
                }
            },

        ]
    },

]